import React from "react";
import Loader from "../../common/Loader";
import { Pill, Timeline } from "../../common/Fiche";

// Points de la chronologie : encres de la charte (colors.scss) pour les
// couleurs du thème renvoyées par l'API ; la pastille reprend le même ton.
const COULEURS = {
  primary: "#0e6bb0", // espoar-blue
  darkblue: "#0a4c80", // espoar-blue-dark
  success: "#0a6e0e", // ok-ink
  info: "#6d1b7b", // info-ink
  danger: "#bf2f38", // danger-ink
  warning: "#8a5a00", // warn-ink
  dark: "#1c2b3a", // ink
};
const TONS = { success: "ok", danger: "ko", info: "info", warning: "warn", dark: "dark" };

// Types techniques d'événement renommés dans le vocabulaire du portail.
const LIBELLES_TYPE = { Rdsp: "RDO" };

export const versItemTimeline = (ev, k) => ({
  id: ev.id || "ev" + k,
  date: ev.date,
  icon: ev.icon,
  color: COULEURS[ev.color] || COULEURS.primary,
  badges: ev.type ? <Pill tone={TONS[ev.color] || "neutral"}>{LIBELLES_TYPE[ev.type] || ev.type}</Pill> : null,
  title: ev.title,
  body: ev.description ? <p className="tl__body">{ev.description}</p> : null,
});

const MonParcours = ({ evenements }) => {
  if (!evenements) return <Loader />;
  return (
    <Timeline items={evenements.map(versItemTimeline)} ariaLabel="Votre parcours" emptyMessage="Aucune étape pour le moment." />
  );
};

export default MonParcours;
